getAllEvents